const Ship = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="28"
      height="28"
      viewBox="0 0 28 28"
    >
      <defs>
        <clipPath id="a">
          <rect width="28" height="28" fill="#fff" stroke="#707070" strokeWidth="1" />
        </clipPath>
      </defs>
      <g>
        <g transform="translate(0.773 5.136)">
          <path
            d="M.442,288.871a2.459,2.459,0,0,0,1.389-.387,3.568,3.568,0,0,1,3.632,0,2.685,2.685,0,0,0,2.777,0,3.566,3.566,0,0,1,3.631,0,2.683,2.683,0,0,0,2.776,0,3.564,3.564,0,0,1,3.63,0,2.68,2.68,0,0,0,2.775,0,3.563,3.563,0,0,1,3.629,0,2.453,2.453,0,0,0,1.387.387.442.442,0,1,1,0,.884,3.314,3.314,0,0,1-1.815-.5,2.68,2.68,0,0,0-2.775,0,3.562,3.562,0,0,1-3.629,0,2.682,2.682,0,0,0-2.776,0,3.565,3.565,0,0,1-3.63,0,2.684,2.684,0,0,0-2.777,0,3.567,3.567,0,0,1-3.631,0,2.686,2.686,0,0,0-2.778,0,3.312,3.312,0,0,1-1.816.5.442.442,0,1,1,0-.884Zm0,0"
            transform="translate(0 -272.082)"
          />
          <path
            d="M26.509,15.463a.442.442,0,0,1-.442.442,3.3,3.3,0,0,1-1.808-.494l-.144-.079a2.366,2.366,0,0,0-1.25-.309,2.452,2.452,0,0,0-1.386.387,3.567,3.567,0,0,1-3.63,0,2.686,2.686,0,0,0-2.778,0,3.565,3.565,0,0,1-3.63,0,2.683,2.683,0,0,0-2.776,0,3.565,3.565,0,0,1-3.629,0,2.548,2.548,0,0,0-.942-.357,3.091,3.091,0,0,0-.449-.031,2.451,2.451,0,0,0-1.386.387,3.313,3.313,0,0,1-1.818.5.442.442,0,0,1,0-.884,2.458,2.458,0,0,0,1.39-.387,3.3,3.3,0,0,1,1.5-.486L.072,9.074a.442.442,0,0,1,.37-.68H4.261L9.828,3.871a5.448,5.448,0,0,1,3.426-1.22h4.624L19.513.2a.442.442,0,0,1,.369-.2h2.651a.442.442,0,0,1,.436.514l-.356,2.137h.362c.607,0,1.325.479,1.325.884v4.86h1.767a.442.442,0,0,1,.425.563l-1.648,5.766a2.335,2.335,0,0,0,1.223.3.442.442,0,0,1,.442.442ZM10.385,4.556,9.469,5.3h4.669a1.311,1.311,0,0,0,1.325-1.325V3.534H13.254a4.567,4.567,0,0,0-2.869,1.022Zm9.938-1.022H16.347v.442A2.187,2.187,0,0,1,15.894,5.3H19a1.311,1.311,0,0,0,1.325-1.325ZM22.01.884H20.118L18.94,2.651h2.776Zm1.405,2.823a.787.787,0,0,0-.442-.172H21.207v.442A2.212,2.212,0,0,1,19,6.185H8.394V6.175L5.662,8.394H23.416ZM24.3,9.278H1.251l3.174,4.937a3.541,3.541,0,0,1,1.036.42,2.686,2.686,0,0,0,2.777,0,3.565,3.565,0,0,1,3.63,0,2.683,2.683,0,0,0,2.776,0,3.565,3.565,0,0,1,3.629,0,2.685,2.685,0,0,0,2.777,0,3.3,3.3,0,0,1,1.813-.5,3.341,3.341,0,0,1,1.174.19l1.443-5.05Zm0,0"
            transform="translate(0 0)"
          />
        </g>
      </g>
    </svg>
  );
};

export default Ship;
